<template>
  <!-- container -->
  <div class="container">
    <!-- shadow-box -->
    <div class="shadow-box login-box">
      <!-- login-wrap -->
      <div class="login-wrap">
        <!-- logo -->
        <div class="logo">
          <img src="/img/common/logo.svg" alt="" />
          <span class="logo-text">LOGIN</span>
          <span class="logo-desc">건설현장 품질관리 Q박스 - Cabinet</span>
        </div>
        <!-- // logo -->

        <!-- field-wrapper -->
        <div class="field-wrapper">
          <div class="field-box">
            <div class="label">이메일 ID</div>
            <div class="field">
              <input
                v-model="login.email"
                type="text"
                class="txt"
                placeholder="@ 포함 입력"
              />
              <span class="error">{{ emailError }}</span>
            </div>
          </div>
          <div class="field-box">
            <div class="label">비밀번호</div>
            <div class="field">
              <input
                v-model="login.passwd"
                type="password"
                class="txt"
                @keyup.enter="processLogin"
              />
              <span class="error">{{ passwdError }}</span>
            </div>
          </div>
          <div class="btn-box">
            <button
              type="button"
              class="btn"
              style="margin-bottom: 20px"
              :disabled="btnDisabled"
              @click="processLogin"
            >
              <span>로그인</span>
            </button>
          </div>
        </div>
        <!-- // field-wrapper -->
      </div>
      <!-- // login-wrap -->
    </div>
    <!-- // shadow-box -->
  </div>
  <!-- // container -->
</template>
<script>
import {
  USER_ID,
  USER_EMAIL,
  PHOTO_ID,
  AUTO_YN,
  JWT_TOKEN,
  JWT_REFRESH_TOKEN,
  NAME,
  POSITION,
  USER_AUTH,
  SITE_NAME,
  SITE_TYPE,
  SITE_USE_REQUEST,
  SITE_USE_TESTTYPE,
  SITE_USE_MIXTURE_DESIGN,
  SITE_USE_SHOTCRETE,
  SITE_USE_REMICON_BOOK,
  SITE_USE_28SIGN,
  SITE_USE_BOOK_TEMPLATE_EXCEL,
  SITE_USE_DOC_NO,
  SITE_ID,
  SITE_USE_COL_UNIT_SPEC,
  ALLOWED_SYSTEM,
  SYSTEM_TYPE,
  SITE_USE_REQ_CONCAT_TEST_NO,
  SITE_USE_MULTI_REMICON_TEST_NO,
  SITE_USE_DISPLAY_WRITER,
  DEVICE_ID,
} from "@/const";
import AuthApi from "@/api/AuthApi";
import SystemApi from "@/api/SystemApi";
import SiteApi from "@/api/SiteApi";
export default {
  name: "Login",
  components: {},
  data: () => {
    return {
      login: {
        email: "",
        passwd: "",
        deviceId: DEVICE_ID,
        isLongToken: false,
      },
      emailError: "",
      passwdError: "",
    };
  },
  computed: {
    btnDisabled() {
      return !(this.login.email.length > 2 && this.login.passwd.length > 2);
    },
  },
  created() {},
  mounted() {
    // cabinet 스토어에는 hideLoading/hideDocLoading 액션이 없어 기존 호출은 vuex unknown action 에러였음 — 제거
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.redirectUrl = urlParams.get("redirectUrl");
    this.invitationCode = urlParams.get("code");
    const token = urlParams.get("ss");

    if (token) {
      // 내부 로그인 토큰(ss)이 히스토리·로그에 남지 않도록 URL에서 즉시 제거 (토큰 console.log도 유출이라 삭제)
      urlParams.delete("ss");
      const query = urlParams.toString();
      window.history.replaceState(
        window.history.state,
        "",
        window.location.pathname + (query ? `?${query}` : "")
      );
      this.login.internalLoginToken = token;
      AuthApi.internalLogin(this.login).then(
        async (value) => {
          if (value) {
            this.loginAfter(value);
          }
        },
        () => {
          this.passwdError = "가입하지 않았거나 잘못된 비밀번호입니다.";
        }
      );
    }

    // PC(qtestbox.com)에서 넘어온 1회용 SSO 코드 처리 — fragment(#)라 서버 로그·Referer에 남지 않음
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const ssoCode = hashParams.get("sso");
    if (ssoCode) {
      window.history.replaceState(
        window.history.state,
        "",
        window.location.pathname + window.location.search
      );
      // 이전 사용자·현장 캐시(siteStorage 등)가 남지 않도록 비운다
      localStorage.clear();
      AuthApi.ssoLogin({
        ssoCode,
        deviceId: DEVICE_ID,
        isLongToken: false,
      }).then(
        (value) => {
          if (value) {
            this.loginAfter(value);
          }
        },
        () => {
          this.passwdError =
            "자동 로그인에 실패했습니다. 직접 로그인해 주세요.";
        }
      );
    }

    const email = localStorage.getItem(USER_EMAIL);
    const isLongToken = localStorage.getItem(AUTO_YN);

    this.login.email = email ? email : "";
    // localStorage 값은 문자열이라 "false"도 truthy — boolean으로 변환해서 판정
    this.login.isLongToken =
      isLongToken !== null ? isLongToken === "true" : true;
  },
  beforeDestroy() {},
  methods: {
    async processLogin() {
      if (!this.login.email) {
        // this.login.email은 문자열이라 .focus() 호출 시 TypeError — 에러 문구 표시로 대체
        this.emailError = "이메일 ID를 입력하세요.";
        return;
      }

      if (!this.login.passwd) {
        this.passwdError = "비밀번호를 입력하세요.";
        return;
      }
      localStorage.clear();
      AuthApi.login(this.login).then(
        async (value) => {
          if (value) {
            this.loginAfter(value);
          }
        },
        () => {
          this.passwdError = "가입하지 않았거나 잘못된 비밀번호입니다.";
        }
      );
    },
    movePage(target) {
      if (this.$route.name !== target) {
        this.$router.push({
          name: target,
        });
      }
    },
    moveSignup() {
      if (this.invitationCode) {
        this.$router.push({ path: `/signup?code=${this.invitationCode}` });
      } else {
        this.$router.push({ path: `/signup` });
      }
    },
    async loginAfter(value) {
      SystemApi.getenums();

      localStorage.setItem(JWT_TOKEN, value.content.accessToken);
      // refreshToken 미저장으로 토큰 갱신이 항상 실패하던 문제 수정 (pc Login.vue와 동일 처리)
      localStorage.setItem(JWT_REFRESH_TOKEN, value.content.refreshToken);
      localStorage.setItem(NAME, value.content[NAME]);
      localStorage.setItem(USER_ID, value.content.id);
      // SSO 경로는 입력 이메일이 없으므로 응답의 email을 우선 사용
      localStorage.setItem(USER_EMAIL, value.content.email || this.login.email);
      localStorage.setItem(POSITION, value.content[POSITION]);
      localStorage.setItem(USER_AUTH, value.content.grantType);
      localStorage.setItem(NAME, value.content.name);
      localStorage.setItem(PHOTO_ID, value.content.photoId);
      localStorage.setItem(ALLOWED_SYSTEM, value.content.allowedSystem);

      const site = await SiteApi.get();

      localStorage.setItem(SITE_ID, site.content.id);
      localStorage.setItem(SITE_NAME, site.content.name);
      localStorage.setItem(SITE_TYPE, site.content.type);
      localStorage.setItem(SITE_USE_REQUEST, site.content.isUseRequest);
      localStorage.setItem(
        SITE_USE_REMICON_BOOK,
        site.content.isUseRemiconBook
      );
      localStorage.setItem(SITE_USE_TESTTYPE, site.content.isUseTestType);
      localStorage.setItem(
        SITE_USE_MIXTURE_DESIGN,
        site.content.isUseMixtureDesign
      );
      localStorage.setItem(SITE_USE_DOC_NO, site.content.isUseDocNo);
      localStorage.setItem(SITE_USE_SHOTCRETE, site.content.isUseShotcrete);
      localStorage.setItem(SITE_USE_28SIGN, site.content.isUse28sign);
      localStorage.setItem(
        SITE_USE_BOOK_TEMPLATE_EXCEL,
        site.content.isUseBookTemplateExcel
      );
      localStorage.setItem(SITE_USE_COL_UNIT_SPEC, site.content.isUseUnitSpec);
      localStorage.setItem(
        SITE_USE_REQ_CONCAT_TEST_NO,
        site.content.isUseRequestConcatTestNo
      );
      localStorage.setItem(
        SITE_USE_MULTI_REMICON_TEST_NO,
        site.content.isUseMultiRemiconTestNo
      );
      localStorage.setItem(
        SITE_USE_DISPLAY_WRITER,
        site.content.isUseDisplayWriter
      );

      this.$router.push({ path: "/main" });
    },
    onNotification() {},
  },
};
</script>
